import { AfterViewInit, Directive, ElementRef, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[dpadScrollableVertical]'
})
export class DpadScrollableVerticalDirective implements AfterViewInit{

    @Input() scrollTopPaddingPx: number = 200;

    @HostBinding('style.scroll-behavior')
    backgroundColor: string = 'smooth';

    @HostBinding('style.position')
    position: string = 'relative';

    public get isScrollable(): boolean {
        const nElem = this.elem.nativeElement;
        return nElem.scrollHeight > nElem.clientHeight;
    }

    constructor(private elem: ElementRef) {
    }

    ngAfterViewInit() {
    }

    scrollIntoView(element: any, type: string | undefined, padding: number | undefined) {
        let p = padding ?? this.scrollTopPaddingPx;
        const scrollElem: any = this.elem.nativeElement;
        const elRect = element.getBoundingClientRect();
        const scrollRect = scrollElem.getBoundingClientRect();

        let y = 0;

        if (type === undefined || type === 'top' || type === 'left') {
            const scrollElY = scrollRect.y;
            y = elRect.y - scrollElY;
        }

        if (type === 'center') {
            const scrollElY = (scrollRect.y) + (scrollRect.height / 2) - (elRect.height / 2);
            y = elRect.y - scrollElY;
        }

        if (type === 'bottom' || type === 'right') {
            const scrollElY = (scrollRect.y) + (scrollRect.height) - (elRect.height);
            y = elRect.y - scrollElY;
            p = -p;
        }

        scrollElem.scrollTop +=  (y - p);

    }
}
